import classnames from 'classnames';
import React from 'react';
import { useDrag } from 'react-dnd';

import { SidebarPosition } from '@core/types';
import DisplaySetMessageListTooltip from '../DisplaySetMessageListTooltip';
import Icon from '../Icon';
import Tooltip from '../Tooltip';
import Typography from '../Typography';

interface DragData {
	/** Must match the "type" a dropTarget expects */
	type: string;
	// [key: string]: any;
}

interface ThumbnailNoImageProps {
	displaySetInstanceUID: string;
	/**
	 * Data the thumbnail should expose to a receiving drop target. Use a matching
	 * `dragData.type` to identify which targets can receive this draggable item.
	 * If this is not set, drag-n-drop will be disabled for this thumbnail.
	 *
	 * Ref: https://react-dnd.github.io/react-dnd/docs/api/use-drag#specification-object-members
	 */
	dragData: DragData;
	description?: string;
	modality: string;
	/** Tooltip message to display when modality text is hovered */
	modalityTooltip: string;
	seriesDate: string;
	onClick: () => void;
	onDoubleClick: () => void;
	messages?: {
		messages: {
			id: string;
		}[];
	};
	isActive: boolean;
	isHydratedForDerivedDisplaySet?: boolean;
	viewportIdentificator?: string[];
	loadingProgress?: number;
	canReject?: boolean;
	onReject?: () => void;
	sidePosition?: SidebarPosition;
}

const ThumbnailNoImage: React.FC<ThumbnailNoImageProps> = ({
	displaySetInstanceUID,
	description,
	seriesDate,
	modality,
	modalityTooltip,
	onClick,
	onDoubleClick,
	canReject,
	onReject,
	messages,
	dragData,
	isActive,
	isHydratedForDerivedDisplaySet,
	sidePosition,
}) => {
	const [_collectedProps, drag, _dragPreview] = useDrag({
		type: 'displayset',
		item: {
			...dragData,
		},
		canDrag: function (_monitor) {
			return Object.keys(dragData).length !== 0;
		},
	});

	return (
		<div
			className={classnames(
				'flex flex-1 cursor-pointer select-none flex-row rounded outline-none hover:border-blue-300 focus:border-blue-300',
				isActive ? ' border border-primary-light' : 'border border-transparent',
			)}
			style={{
				// padding: isActive ? '10px' : '12px',
				height: `120px`,
				width: `100px`,
			}}
			id={`thumbnail-${displaySetInstanceUID}`}
			onClick={onClick}
			onDoubleClick={onDoubleClick}
			role="button"
			tabIndex={0}
			data-cy={`study-browser-thumbnail-no-image`}
		>
			<Tooltip content={description} position={sidePosition === SidebarPosition.LEFT ? 'right' : 'left'} className="h-full w-full">
				<div ref={drag} className="w-full">
					<div className="flex flex-1 flex-col">
						<div className="mb-2 flex flex-1 flex-row items-center">
							<Icon
								name="list-bullets"
								className={classnames(
									'w-12',
									isHydratedForDerivedDisplaySet ? 'text-primary-light' : 'text-secondary-light',
								)}
							/>
							<Typography>{modality}</Typography>
							{/* <Tooltip position="bottom" content={<Typography>{modalityTooltip}</Typography>}>
							<div
								className={classnames(
									'rounded-sm px-3  text-lg',
									isHydratedForDerivedDisplaySet ? 'bg-primary-light text-black' : 'bg-primary-main text-white',
								)}
							>
								{modality}
							</div>
						</Tooltip> */}
							<DisplaySetMessageListTooltip messages={messages} id={`display-set-tooltip-${displaySetInstanceUID}`} />
						</div>
						<div className="flex flex-row">
							{canReject && (
								<Icon
									name="old-trash"
									style={{
										minWidth: '12px',
									}}
									className="ml-4 w-3 text-red-500"
									onClick={onReject}
								/>
							)}
							<div className="m-1 break-all text-xs text-white text-wrap">{description}</div>
						</div>
					</div>
				</div>
			</Tooltip>
		</div>
	);
};

export default ThumbnailNoImage;
